import { z } from 'zod';
export const VoiceTokenResponse = z.object({
    url: z.string(),
    token: z.string(),
});
//# sourceMappingURL=voice.js.map